import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { IConfig } from '../../../../../../Interfaces/IConfig';
import { IMortgage } from '../../../../../../Interfaces/IMortgage';
import { RealEstateLandRegister } from '../../../PurchaseContract/Components/RealEstate/RealEstateLandRegister';
import { MortgageRealEstateAddress } from '../Components/RealEstate/MortgageRealEstateAddress';

interface IProps {
  configObject: IConfig;
  handleBack: Function;
  handleNext: Function;
  mortgageObject: IMortgage;
  setMortgageObject: Function;
}

export const MortgageLandRegisterData: React.FC<IProps> = ({
  configObject,
  handleBack,
  handleNext,
  mortgageObject,
  setMortgageObject,
}) => {
  const formRef = useRef<HTMLFormElement>(null);
  const [hasAddress, setHasAddress] = useState(
    mortgageObject.RealEstateLandRegistryData
      ? mortgageObject.RealEstateLandRegistryData
      : null
  );
  const [currentObject, setCurrentObject] = useState(mortgageObject.RealEstate);

  const handleSubmit = () => {
    setMortgageObject({
      ...mortgageObject,
      RealEstate: currentObject,
    });
    handleNext();
  };
  const handleOnSave = () => {
    if (formRef.current && formRef.current.checkValidity()) {
      handleSubmit();
    } else if (formRef.current && !formRef.current.checkValidity()) {
      const elements = Array.from(formRef.current.elements).reverse();

      elements.forEach((element: any) => {
        if (element.reportValidity()) {
          element.reportValidity();
        }
      });
    }
  };
  const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    setHasAddress(event.target.value);
    if (event.target.value === 'no') {
      // Alle Grundbuch-Einträge komplett löschen
      setCurrentObject({
        ...currentObject,
        LandParcelEntryArray: [],
      });
    } else if (event.target.value === 'yes') {
      setCurrentObject({
        ...currentObject,
        City: '',
        Postcode: '',
        Street: '',
        StreetNr: '',
        StreetAditional: '',
        Latitude: null,
        Longitude: null,
        idPostcode: null,
      });
    }
  };
  const isFormValid = () => {
    if (formRef.current && formRef.current.checkValidity()) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    setMortgageObject({
      ...mortgageObject,
      RealEstate: currentObject,
      RealEstateLandRegistryData: hasAddress,
    });
  }, [currentObject, hasAddress]);

  return (
    <>
      <form ref={formRef}>
        <Box mt={6}>
          <Typography variant='h6' sx={{ mb: 2 }}>
            Geben Sie die Grundbuchdaten Ihres Grundstücks an, das mit der
            Grundschuld belastet ist bzw. werden soll. Falls Ihnen diese Daten
            nicht vorliegen geben Sie bitte die Adresse des Grundstücks ein.
          </Typography>
          <Typography variant='body1' sx={{ mb: 2 }}>
            Liegen Grundbuchdaten vor?
          </Typography>
          <FormControl component='fieldset'>
            <RadioGroup
              row
              aria-label='property-owned'
              name='property-owned'
              value={hasAddress}
              onChange={handleToggle}
            >
              <FormControlLabel
                value='yes'
                control={<Radio required />}
                label='Ja'
              />
              <FormControlLabel
                value='no'
                control={<Radio required />}
                label='Nein'
              />
            </RadioGroup>
          </FormControl>
          <Box sx={{ mt: 5 }} />
          {hasAddress === 'yes' && (
            <RealEstateLandRegister
              currentObject={currentObject}
              setCurrentObject={setCurrentObject}
            />
          )}
          {hasAddress === 'no' && (
            <MortgageRealEstateAddress
              configObject={configObject}
              currentObject={currentObject}
              setCurrentObject={setCurrentObject}
            />
          )}
        </Box>

        <Box mt={10} sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
          <Button
            variant='outlined'
            onClick={() => handleBack()}
            sx={{ mr: 1 }}
          >
            Zurück
          </Button>
          <Box sx={{ flex: '1 1 auto' }} />
          <Button
            onClick={() => {
              handleOnSave();
            }}
            variant={isFormValid() ? 'contained' : 'outlined'}
          >
            Weiter
          </Button>
        </Box>
      </form>
    </>
  );
};
